import React from "react"
import styled from "styled-components"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import Title from "../Title"
import StyledSmallTitle from "../styled/styledSmallTitle"
import Paragraph from "../styled/styledParagraph"
import Button, { StyledButton } from "../Button"

const StyledSection = styled.section`
  padding: 64px 16px 0;
  background-color: #fffcfa;
  & .first-paragraph {
    margin: 32px 0 24px;
  }
  & .second-paragraph {
    margin: 24px 0 16px;
  }
  @media (min-width: 768px) {
    padding: 170px 16px 0;
    max-width: 576px;
    margin: 0 auto;
  }
  @media (min-width: 1024px) {
    max-width: 900px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 65px;
    align-items: center;
    & .first-paragraph {
      margin: 0 0 40px;
    }
    & .second-paragraph {
      margin: 0 0 40px;
    }
  }
  @media (min-width: 1200px) {
    max-width: 1200px;
    grid-column-gap: 130px;
  }
`

const Box = styled.div`
  @media (min-width: 1024px) {
    display: flex;
    flex-direction: column;
  }
`

const Picture = styled(Img)`
  display: block;
  &.desktop-casestudy {
    display: none;
  }
  @media (min-width: 1024px) {
    display: none;
    &.desktop-casestudy {
      display: block;
    }
  }
`
const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  ${StyledButton} {
    margin-bottom: 16px;
  }
  @media (min-width: 1024px) {
    flex-direction: row-reverse;
    ${StyledButton} {
      margin-bottom: 0;
      margin-left: 30px;
      width: 100%;
      &:last-child {
        margin-left: 0;
      }
    }
  }
`

const LastCaseStudy = () => {
  const { caseStudyPic } = useStaticQuery(graphql`
    query {
      caseStudyPic: file(relativePath: { eq: "academua-desktop.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return (
    <StyledSection>
      <Picture
        fluid={caseStudyPic.childImageSharp.fluid}
        alt="Academua - projekt aplikacji"
        title="Prezentacja aplikacji Academua"
        className="desktop-casestudy"
      />
      <Box>
        <StyledSmallTitle>ANALIZA PROJEKTU (Już wkrótce)</StyledSmallTitle>
        <Title>
          <span>Nauka wizażu online</span>, projekt aplikacji webowej Academua.
        </Title>
        <Paragraph className="first-paragraph">
          Zaprojektowaliśmy aplikację internetową do nauki wizażu online,
          umożliwia ona skuteczną naukę wizażu przez internet i otrzymanie
          certyfiaktu po ukończeniu kursu.
        </Paragraph>
        <Picture
          fluid={caseStudyPic.childImageSharp.fluid}
          alt="Academua - projekt aplikacji"
          title="Prezentacja aplikacji Academua"
        />
        <Paragraph className="second-paragraph">
          Dodatkowo na prośbę klienta stworzyliśmy własny player video z opcją
          dodawania zakładek umożliwiających łatwiejszą naukę.
        </Paragraph>
        <Buttons>
          <StyledButton
            secondary
            style={{ backgroundColor: "#fff", color: "#000" }}
            disabled
          >
            Wszystkie prace
          </StyledButton>
          <Button disabled>Zobacz projekt</Button>
        </Buttons>
      </Box>
    </StyledSection>
  )
}

export default LastCaseStudy
